'use strict';

angular.module('shiftTraderApp')
  .factory('Organizations', function (ServerUrls, $http, Departments, Session, $q, $rootScope, $timeout,
                                      Subscriptions, StatisticsService, SandboxService, $state, $uibModalStack) {
    var path = ServerUrls.current.railsApi + 'organizations/';
    var nodePath = ServerUrls.current.nodeApi.slice(0, -3) + 'v2/organizations/';
    var defaultLogoFilename = 'missing.png';

    var Organization = function(initData) {
      var org = {};
      angular.extend(org, initData);

      if (org.active_until) {
        org.active_until = moment.utc(org.active_until).tz(Session.getTimezone());
      }

      if (org.paid_thru) {
        org.paid_thru= moment.utc(org.paid_thru).tz(Session.getTimezone());
      }

      if (org.trial_start_dt) {
        org.trial_start_dt = moment.utc(org.trial_start_dt).tz(Session.getTimezone());
      }

      if (org.trial_end) {
        org.trial_end = moment.utc(org.trial_end).tz(Session.getTimezone());
      }

      org.$isInTrialMode = function() {
        var nowMoment = moment();
        return org.trial_start_dt && org.trial_start_dt.isBefore(nowMoment) &&
            org.trial_end && org.trial_end.isAfter(moment());
      };

      if (!lodash.isUndefined(org.departments)) {
        if (org.departments.length > 0) {
          org.departments = lodash.map(org.departments, function (dept) {
            return Departments.initWithData(dept);
          });
        }

        if (lodash.findIndex(org.departments, {id: null}) < 0) {
          org.departments.push({
            id: null,
            name: 'Uncategorized',
            active: true
          });
        }
      } else {
        org.departments = [];
      }

      org.$isInSandboxMode = function() {
        return !lodash.isEmpty(org.demo_metadata) && org.demo_metadata.filled_at && !org.demo_metadata.emptied_at;
      };

      if (!lodash.isEmpty(org.demo_metadata) && org.demo_metadata.filled_at) {
        org.demo_metadata._filled_at_mmnt = moment(org.demo_metadata.filled_at * 1000);
      }

      if (org.demo_metadata) {
        SandboxService.setSandboxData({
          info: org.demo_metadata,
          mode: org.$isInSandboxMode()
        });
      }

      org.$hasCustomLogo = function() {
        if (lodash.has(org, 'logo_urls')) {
          return org.logo_urls.tiny.slice(defaultLogoFilename.length * -1) !== defaultLogoFilename;
        } else {
          return undefined;
        }
      };

      org.formattedPhoneNumber = function() {
        if (org.organization_config.phone_number) {
          var temp = org.organization_config.phone_number.replace(/[^0-9]/g,'');
          return temp.replace(/[1]?(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        } else {
          return 'Not provided';
        }
      };

      org.$update = function(data) {
        var that = this;
        return $http.put(path + this.id, data)
          .then(function(response) {
            angular.extend(that, response.data);  //copy in new properties from server
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      org.getSubscriptions = function() {
        return $http.get(ServerUrls.current.railsApi + 'organizations/' + org.id + '/subscriptions')
          .then(function(response) {
            return lodash.map(response.data, function(x) {
              return Subscriptions.initWithData(x, org);
            });
          }, function(response) {
            return $q.reject(response);
          });
      };

      org.createCreditCard = function(token_id) {
        return $http.post(ServerUrls.current.railsApi + 'organizations/' + org.id + '/credit_cards', {credit_card: {token_id: token_id}})
          .then(function(response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      org.deleteCreditCard = function(card_id) {
        return $http.delete(ServerUrls.current.railsApi + 'organizations/' + org.id + '/credit_cards/' + card_id)
          .then(function(response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      org.getCreditCard = function() {
        return $http.get(ServerUrls.current.railsApi + 'organizations/' + org.id + '/credit_cards')
          .then(function(response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      org.getLastCardCharge = function(card_id) {
        return $http.get(ServerUrls.current.railsApi + 'organizations/' + org.id + '/credit_cards/' + card_id + '/last_charge')
          .then(function(response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          })
      };

      org.getChargeStatus = function(charge_id) {
        return $http.get(ServerUrls.current.railsApi + 'organizations/' + org.id + '/charges/' + charge_id + '/charge_status')
          .then(function(response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          })
      };

      /**
       * Retrieves the invoice history starting at "start" until
       * "amount" number of records have been retrieved.
       * @param  {Integer} start  Starting index of records to get
       * @param  {Integer} amount Number of records to retrieve
       * @return {object}         Returns retrieved records
       */
      org.getInvoiceHistory = function(offset, limit) {
        return $http.get(ServerUrls.current.railsApi + 'organizations/' + org.id + '/charges', {params: {offset: offset, limit: limit}})
          .then(function(response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };


      org.$getStatistic = function(statName, options) {
        return StatisticsService.getOrgStatistic(org.id, statName, options);
      };

      org.$getStore = function() {
        return $http.get(ServerUrls.current.railsApi + 'organizations/' + org.id + '/store')
          .then(function(response) {
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      org.$updatePlan = function(planType, planId) {
        var data = {};

        if (planType) {
          data.plan_type = planType;
        }

        if (planId) {
          data.plan_id = planId;
        }

        return $http.post(ServerUrls.current.railsApi + 'organizations/' + org.id + '/update_plan', data)
          .then(function(response) {
            org.queued_plan_type = response.data.queued_plan_type;
            org.queued_plan_id = response.data.queued_plan_id;
            org.subscribed = response.data.subscribed;
            org.last_plan_id = response.data.last_plan_id;
            org.active_until = response.data.active_until;
            org.paid_thru = response.data.paid_thru;
            return org;

          }, function(response) {

            return $q.reject(response);
          });
      };

      return org;
    };

    var Organizations = {};
    Organizations.getById = function (id, setSession) {
      return $http.get(nodePath + id)
        .then(function (response) {
          if (!lodash.isUndefined(setSession)) {
            Session.setCurrentOrgId(response.data.id);
            if (response.data.organization_config && response.data.organization_config.timezone) {
              Session.setTimezone(response.data.organization_config.timezone);
            }
          }
          return new Organization(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    Organizations.getCurrentOrg = function() {
      var theOrgId = Session.getCurrentOrgId();
      if (lodash.isUndefined(theOrgId) || lodash.isNull(theOrgId)) {
        theOrgId = 'primary';
      }

      return Organizations.getById(theOrgId, true);
    };

    Organizations.initWithData = function(data) {
      return new Organization(data);
    };

    Organizations.startTrial = function(orgId, planId, couponName) {
      return $http.post(ServerUrls.current.railsApi + 'organizations/' + orgId + '/start_trial', {plan_id: planId, coupon: couponName || null })
        .then(function(response) {
          SandboxService.setSandboxData(false);
          $uibModalStack.dismissAll();
          $rootScope.$broadcast('flushCaches')
          $state.go('organizationProfile.show', {orgId: orgId}, { reload: true });
          $rootScope.$broadcast('sa:demoTour:refreshBar')

        }, function(response) {
          return $q.reject(response);
        });
    };

    Organizations.restartDemo = function (orgId) {
      return $http.get(ServerUrls.current.railsApi + 'organizations/' + orgId + '/restart_demo')
        .then(function (response) {
          $rootScope.$broadcast('flushCaches')
          return response
        }, function (response) {
          return $q.reject(response)
        })
    }

    return Organizations;
  });
